import Navigation from 'components/Navigation';
import createAsyncModule from 'hocs/createAsyncModule';
import Cookies from 'js-cookie';
import { optIn } from 'modules/global/actions';
import {
  setUserCookiesData,
  showCreate,
  showLogin,
} from 'modules/user/actions';
import { AUTH_TOKEN_ID } from 'modules/user/constants';
import { isAuthenticated } from 'modules/user/reducers';
import React, { Component, Fragment, useEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import BrandHeading from './components/BrandHeading';
import Footer from './components/Footer';

export const Dialogs = createAsyncModule('dialogs');
export const Start = createAsyncModule('start');
export const Search = createAsyncModule('search');
export const Subscriptions = createAsyncModule('subscriptions');
export const Toast = createAsyncModule('toasters');
export const User = createAsyncModule('user');
export const Following = createAsyncModule('following');
export const SearchTool = createAsyncModule('searchTool');
const USER_COOKIES_DATA = 'mnd_meta';

Dialogs.preload && Dialogs.preload();
User.preload && User.preload();
Following.preload && Following.preload();

const PendingLogin = ({ openLogin }) => {
  useEffect(() => {
    openLogin();
  }, []);

  return null;
};

class Global extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserLoggedIn:
        !!localStorage.getItem(AUTH_TOKEN_ID) ||
        !!Cookies.get(USER_COOKIES_DATA),
    };
  }

  componentDidMount() {
    const savedToken = localStorage.getItem(AUTH_TOKEN_ID);
    if (!savedToken && window.location.search.indexOf('token=') === -1) {
      this.props.optIn();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isAuthenticated !== prevProps.isAuthenticated) {
      this.setState({ isUserLoggedIn: this.props.isAuthenticated });
    }
  }

  render() {
    const { isAuthenticated, t, showCreate, showLogin } = this.props;
    const { isUserLoggedIn } = this.state;

    return (
      <Fragment>
        <Toast timeout={7000} hasClose={true} />
        <Dialogs />
        <Following />
        <User />
        <div className="mnd-global-header">
          <Navigation />
          <div className="mnd-column-full visible">
            <Route
              path="/"
              exact
              render={() => (
                <BrandHeading value={t('global_brand-heading_text')} />
              )}
            />
            <SearchTool />
            {!isAuthenticated && (
              <Route
                path="/"
                exact
                render={() => (
                  <div className="mnd-start-hero__action-call">
                    <h2>{t('global_hero-action_heading')}</h2>
                    <button
                      className="mnd-button mnd-button--submit track-element"
                      onClick={showCreate}
                      data-event-category="Form"
                      data-event-action="Reader account"
                      data-event-label="Step 1 - page"
                    >
                      {t('global_hero-action_button')}
                    </button>
                  </div>
                )}
              />
            )}
          </div>
        </div>
        <Switch>
          <Route path="/" component={Start} exact />
          <Route path="/stories" component={Search} exact />
          <Route path="/organisations" component={Search} exact />
          <Route
            exact
            path="/following"
            render={() =>
              !isUserLoggedIn ? (
                <PendingLogin openLogin={showLogin} />
              ) : (
                <Subscriptions />
              )
            }
          />
          <Route
            exact
            path="/alerts"
            render={() =>
              !isUserLoggedIn ? (
                <PendingLogin openLogin={showLogin} />
              ) : (
                <Subscriptions />
              )
            }
          />
          <Redirect to="/" />
        </Switch>
        <div className="mnd-column-footer">
          <Footer />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: isAuthenticated(state),
});

const mapDispatchToProps = dispatch => ({
  showCreate: () => dispatch(showCreate()),
  showLogin: () => dispatch(showLogin()),
  optIn: () => dispatch(optIn()),
  setUserCookiesData: data => dispatch(setUserCookiesData(data)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withNamespaces()(Global)),
);
